import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CombinedFormLayout from 'components/CombinedFormLayout';
import { useTranslation } from 'next-i18next';
import hasAuthToken from 'lib/hasAuthToken';

const UploadCvPage = () => {
  const { t } = useTranslation();

  return (
    <CombinedFormLayout translationKey="uploadCv">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: t('uploadCv.summary') }} />
    </CombinedFormLayout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default UploadCvPage;
